const resolveLogoSrc = ({
  src,
  colorScheme = "light"
}) => {
  if (!src) {
    return null;
  }

  if (typeof src === "string") {
    return src;
  }

  return (
    src[colorScheme] ??
    src.light ??
    src.dark ??
    null
  );
};


export const getResolvedLogos = ({
  logos = [],
  colorScheme = "light"
} = {}) => {
  if (!Array.isArray(logos)) {
    return [];
  }

  return logos
    .map((logo) => ({
      ...logo,
      src: resolveLogoSrc({
        src: logo.src,
        colorScheme
      })
    }))
    .filter((logo) => Boolean(logo.src))
    .sort(
      (a, b) =>
        (a.priority ?? 0) -
        (b.priority ?? 0)
    );
};


export const getResolvedLogosByIds = ({
  logos = [],
  ids = [],
  colorScheme = "light"
} = {}) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return [];
  }

  return getResolvedLogos({
    logos,
    colorScheme
  }).filter((logo) =>
    ids.includes(logo.id)
  );
};